import React from 'react'
import Zoom from 'react-reveal/Zoom';
import Prog from '../Images/Prog.jpg'
import './Blog.css'
import 'flowbite'
const BlogMe = () => {
  return (
      <>
      <Zoom>
   <h1 className='text-center text-2xl'>Blog </h1>
   <section className="text-gray-600 body-font">
  <div className="container px-5 py-24 mx-auto">
    <div className="flex flex-wrap -m-4">
      <div className="p-4 md:w-1/3">
        <div className="h-full border-2 border-gray-200 border-opacity-60 rounded-lg overflow-hidden">
          <img className="lg:h-48 md:h-36 w-full object-cover object-center" src="https://wolfgunner.hashnode.dev/_next/image?url=https%3A%2F%2Fcdn.hashnode.com%2Fres%2Fhashnode%2Fimage%2Fupload%2Fv1645943315978%2FRucKQqjww.jpg%3Fw%3D1600%26h%3D840%26fit%3Dcrop%26crop%3Dentropy%26auto%3Dcompress%2Cformat%26format%3Dwebp&w=1920&q=75" alt="blog"/>
          <div className="p-6">
            <h2 className="tracking-widest text-xs title-font font-medium text-gray-400 mb-1">Tech Knowledge</h2>
            <h2 className="title-font text-lg font-medium text-rose-500 mb-3">Blockchain development introduction</h2>
            <p className="leading-relaxed mb-3">In the Current World Scenario, Cryptocurrency is getting more popular and people becoming millionaires effectively. Well, People Often say that Banks will not give their security to your Cryptocurrency but this is only A Surface, Real thing is behind the Cryptocurrency that is Blockchain.
</p>
            <div className="flex items-center flex-wrap ">
              <a href='https://wolfgunner.hashnode.dev/blockchain-development-introduction' className="text-indigo-500 inline-flex items-center md:mb-2 lg:mb-0">Learn More
                <svg className="w-4 h-4 ml-2" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M5 12h14"></path>
                  <path d="M12 5l7 7-7 7"></path>
                </svg>
              </a>
             

            </div>
          </div>
        </div>
      </div>
      <div className="p-4 md:w-1/3">
        <div className="h-full border-2 border-gray-200 border-opacity-60 rounded-lg overflow-hidden">
          <img className="lg:h-48 md:h-36 w-full object-cover object-center" src="https://wolfgunner.hashnode.dev/_next/image?url=https%3A%2F%2Fcdn.hashnode.com%2Fres%2Fhashnode%2Fimage%2Fupload%2Fv1645885610621%2F2PVqbL8Fh.webp%3Fw%3D1600%26h%3D840%26fit%3Dcrop%26crop%3Dentropy%26auto%3Dcompress%2Cformat%26format%3Dwebp&w=1920&q=75" alt="blog"/>
          <div className="p-6">
            <h2 className="tracking-widest text-xs title-font font-medium text-gray-400 mb-1">HACKING</h2>
            <h2 className="title-font text-lg font-medium text-rose-500 mb-3">Hack SomeOne's Phone and Get their Sneaky Photos.
</h2>
            <p className="leading-relaxed mb-3">Today, We are going to Cover a Hacking Method that is somewhat similar to Social engineering. Phishing is an act where someone tricks you to get your personal information from you and that information can be a Media or your Accounts Passwords or Something Personal. </p>
            <div className="flex items-center flex-wrap">
              <a href='https://wolfgunner.hashnode.dev/hack-someones-phone-and-get-their-sneaky-photos' className="text-indigo-500 inline-flex items-center md:mb-2 lg:mb-0">Learn More
                <svg className="w-4 h-4 ml-2" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M5 12h14"></path>
                  <path d="M12 5l7 7-7 7"></path>
                </svg>
              </a>
            
            </div>
          </div>
        </div>
      </div>
      <div className="p-4 md:w-1/3">
        <div className="h-full border-2 border-gray-200 border-opacity-60 rounded-lg overflow-hidden">
          <img className="lg:h-48 md:h-36 w-full object-cover object-center" src="https://wolfgunner.hashnode.dev/_next/image?url=https%3A%2F%2Fcdn.hashnode.com%2Fres%2Fhashnode%2Fimage%2Fupload%2Fv1647583208850%2FVIWZjU3n4.jpeg%3Fw%3D1600%26h%3D840%26fit%3Dcrop%26crop%3Dentropy%26auto%3Dcompress%2Cformat%26format%3Dwebp&w=1920&q=75" alt="blog"/>
          <div className="p-6">
            <h2 className="tracking-widest text-xs title-font font-medium text-gray-400 mb-1">Hacking</h2>
            <h2 className="title-font text-lg font-medium text-rose-500 mb-3">How Hackers get free subscription of any Website
</h2>
            <p className="leading-relaxed mb-3">Getting a Full-time Subscription or Membership is Very costly and unfavorable in these days. These subscriptions can be from Media watching sites, Shopping sites or any other real-world Dealership sites.

Today I am going to tell you how hackers get the free membership of any sites by their skills of hacking. For Today's Experiment, We will use Juice Website named OWASP JUICE SHOP</p>
            <div className="flex items-center flex-wrap ">
              <a href='https://wolfgunner.hashnode.dev/how-hackers-get-free-subscription-of-any-website' className="text-indigo-500 inline-flex items-center md:mb-2 lg:mb-0">Learn More
                <svg className="w-4 h-4 ml-2" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M5 12h14"></path>
                  <path d="M12 5l7 7-7 7"></path>
                </svg>
              </a>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<a href='https://wolfgunner.hashnode.dev/' target={'_blank'}>
<button className='dholu'>
  <svg height="24" width="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"></path><path d="M5 13c0-5.088 2.903-9.436 7-11.182C16.097 3.564 19 7.912 19 13c0 .823-.076 1.626-.22 2.403l1.94 1.832a.5.5 0 0 1 .095.603l-2.495 4.575a.5.5 0 0 1-.793.114l-2.234-2.234a1 1 0 0 0-.707-.293H9.414a1 1 0 0 0-.707.293l-2.234 2.234a.5.5 0 0 1-.793-.114l-2.495-4.575a.5.5 0 0 1 .095-.603l1.94-1.832C5.077 14.626 5 13.823 5 13zm1.476 6.696l.817-.817A3 3 0 0 1 9.414 18h5.172a3 3 0 0 1 2.121.879l.817.817.982-1.8-1.1-1.04a2 2 0 0 1-.593-1.82c.124-.664.187-1.345.187-2.036 0-3.87-1.995-7.3-5-8.96C8.995 5.7 7 9.13 7 13c0 .691.063 1.372.187 2.037a2 2 0 0 1-.593 1.82l-1.1 1.039.982 1.8zM12 13a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" fill="currentColor"></path></svg>
  <span>More Blog At</span>
</button>
</a>
</Zoom>
   </>
  )
}

export default BlogMe
